import React from 'react'
import {
  AppBar,
  IconButton,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { X } from 'react-feather'
import { useReactiveVar } from '@apollo/client'
import { SystemContainerBreadcrumbs } from './SystemContainerBreadcrumbs'
import { projectVar, activeVersionVar } from '../../apollo/reactive-vars'

export const useHeaderStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 2,
    background: theme.palette.primary.main,
  },
  toolbar: {
    height: theme.spacing(10),
  },
  appBarButton: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    margin: theme.spacing(2),
  },
}))

type Props = {
  closeLabel: string
  onClose: () => void
  containerName: string
}

export function SystemContainerHeader({
  closeLabel,
  onClose,
  containerName,
}: Props): React.ReactElement {
  const classes = useHeaderStyles()
  const project = useReactiveVar(projectVar)
  const version = useReactiveVar(activeVersionVar)

  const breadcrumbs = [
    { name: project?.name ?? '' },
    { name: version?.name ?? '' },
    { name: containerName },
  ]

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          id="close-drawer"
          className={classes.appBarButton}
          onClick={onClose}
          data-testid="close-drawer"
        >
          <X />
        </IconButton>

        <Typography variant="body2">{closeLabel}</Typography>

        <SystemContainerBreadcrumbs breadcrumbs={breadcrumbs} />
      </Toolbar>
    </AppBar>
  )
}
